var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9283 4.69665C18.8573 7.62559 18.8573 12.3743 15.9283 15.3033M13.7189 6.90643C15.4274 8.61498 15.4274 11.3851 13.7189 13.0936M5.625 6.875L9.55806 2.94194C9.95179 2.54821 10.625 2.82707 10.625 3.38388V16.6161C10.625 17.1729 9.95179 17.4518 9.55806 17.0581L5.625 13.125H3.75755C3.02476 13.125 2.33825 12.7029 2.14364 11.9965C1.96854 11.3608 1.875 10.6913 1.875 10C1.875 9.30868 1.96854 8.6392 2.14364 8.00353C2.33825 7.29706 3.02476 6.875 3.75755 6.875H5.625Z",
    stroke: "white",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeNew);
export default __webpack_public_path__ + "static/media/volume-new.2945d6c7db0f6d910b13b49f8d0b35d5.svg";
export { ForwardRef as ReactComponent };